import React from 'react';
import HeroSection from '../components/home/HeroSection';
import AboutSection from '../components/home/AboutSection';
import ServicesSection from '../components/home/ServicesSection';
import NewsSection from '../components/home/NewsSection';
import PartnersSection from '../components/home/PartnersSection';
const Home = () => {
  return (
    <div className="min-h-screen page-public-bg">
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <NewsSection />      <PartnersSection />
    </div>
  );
};

export default Home;
